<template>
	<div id="app">
		<!-- <Header /> -->

		<router-view />

		<!-- <Rooter /> -->
	</div>
</template>

<script>
	// import Header from './layout/header.vue'
	// import Rooter from './layout/rooter.vue'

	export default {
		name: 'App',
		components: {
			// Header,
			// Rooter
		},
		mounted() {
			document.title = '职教数';
		}
	}
</script>

<style scoped>
	@font-face {
		font-family: Rubik;
		src: url("./assets/fonts/Rubik-Light.ttf");
		src: url("./assets/fonts/rubik-regular-webfont.ttf");
		src: url("./assets/fonts/Rubik-Medium.ttf");
	}

	@font-face {
		font-family: DigifaceWide;
		src: url("./assets/fonts/digifaw.ttf");
	}

	#app {
		background-image: url("https://syzsoss.oss-cn-chengdu.aliyuncs.com/202606/18114234-61060127935991720.png");
		background-repeat: no-repeat;
		background-color: #021737;
		background-size: 100% auto;
	}
</style>